/**
 * [Ref] - Denotes Pseudo Code Reference  
 *  
 * This component is the RMA. .
 * 
 * App Name: WalmartWeb
 * Author: Aparna
 * Created Date: 9/1/20201
 */
import React, { Component } from 'react';
/**
 * Ref: RR_PC_02
 * Importing the action and store file and set to an object.
 */
import * as RMAAction from '../actions/RMAAction';
import RMAStore from '../stores/RMAStore';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import * as $ from 'jquery';
import ReactPaginate from 'react-paginate';
import DatePicker from "react-datepicker";
import BreadCrumpData from '../stores/BreadCrumpStore';
import * as MenuAction from '../actions/MenuAction';
import { withTranslation, Trans } from 'react-i18next'
import Select from 'react-select';
import swal from 'sweetalert';
let isFromLink = false;
let strurlParams = "";
let qp = ""
let currentPagePath;
//Regression bug 4288 -Yuvarani K.
let sortVal=""
let mob_Session_USERID = ""
let mob_Session_BUSUNIT = ""
let Token = ""
let Password = ""
/*[09/11/23, PC_CPW_113_08, Vishwa S]*/
let SESSION_TRUCK_USER = ""
let ReasonChangedArr = [] /*[30/11/23, PC_CPW_113_18, Vishwa S]*/

/*[08/22/22 , PC_04]Accessing STKIssueCart and RMA from mobile for web view - Priyanka D*/
const urlParams = window.location.search;
if (urlParams.includes("?qp_mob")) {
    strurlParams = urlParams.toString()
    if (strurlParams.includes("?qp_mob")) {

        let StrURL = strurlParams.split("?qp_mob=")
        let DecodedQueryparams = StrURL[1].toString();
        qp = atob(DecodedQueryparams);
        let QueryParams = qp.split("&")
        mob_Session_USERID = QueryParams[0].replace("mob_Session_USERID=", "");
        mob_Session_BUSUNIT = QueryParams[1].replace("mob_Session_BUSUNIT=", "");
        Password = QueryParams[2].replace("Password=", "");
        Token = QueryParams[3].replace("Token=", "");
        if (QueryParams.length >= 6) {
            SESSION_TRUCK_USER = QueryParams[5].replace("mob_SESSION_TRUCK_USER=", ""); /*[14/11/23, PC_CPW_113_13, Vishwa S]*/
            //console.error("RMATest", QueryParams[5])
        }
        if (mob_Session_USERID || mob_Session_BUSUNIT || Token) {
            isFromLink = true;
            //Update the User ID and Token in cookie to invoke secure controller
            CookieService.updateLocalStorageValues("Session_UserID", mob_Session_USERID)
            CookieService.setCookieValues(SDIConstants.access_token, Token)
        }
    }
}
const backgout = {
    backgroundColor: "white",
}
const options = [

    {
        value: '1', label: 'Order Number'

    },
    {
        value: '2', label: 'Product ID'
    },
    {
        value: '3', label: 'Employee ID'
    },
    {
        value: '4', label: 'Serial ID'
    },
    {
        value: '5', label: 'Description'
    },
    {
        value: '6', label: 'Charge Code'
    },
    {
        value: '7', label: 'Work Order'
    }
]
const ReasonOption = [

    {
        value: 'CUSTERR', label: 'Customer Error'

    },
    {
        value: 'DAMAGED', label: 'Item Damaged'
    },
    {
        value: 'INTFCRMA', label: 'Return to Inventory created by interface' //CPW-113 Vishwa S
    },
    {
        value: 'ISAERROR', label: 'Incorrect Material Ordered'
    },
    {
        value: 'MECORRECTN', label: 'Match Exception Correction'
    },
    {
        value: 'RECOVERY', label: 'Recovery'
    },
    {
        value: 'SUPP ERROR', label: 'Supplier Error'
    }
]
class RMAComponent extends Component {
    /**
    * RR_PC_02
    * Define the constructor that takes props as parameter
    * 
    * @param props
    */


    constructor(props) {

        super(props);
        this.RMAPageLoadResponse = this.RMAPageLoadResponse.bind(this);
        this.SearchButtonClickResponse = this.SearchButtonClickResponse.bind(this);
        this.GridDataBind = this.GridDataBind.bind(this);
        //CPW-113 Vishwa S
        if (!isFromLink) {
            SESSION_TRUCK_USER = CookieService.getLocalStorageValues("Session_TRUCK_USER");
        }
        /**
       * Ref: RR_PC_03
       * Set the initial values of the state variables
       */
        this.state = {
            GridData: [],
            BuDD: [],
            EmpDD: [],
            BuBoolean: false,
            Empval: "",
            SearchByOption: options,
            RContainsAny: true,
            RContainsAll: false,
            StartDate: "",
            EndDate: "",
            Cirteria: "",
            /*[09/11/23, PC_CPW_113_09, Vishwa S]*/
            EmpId: (SESSION_TRUCK_USER == "True" && SESSION_TRUCK_USER !== undefined && SESSION_TRUCK_USER !== null ? (isFromLink ? mob_Session_USERID : CookieService.getLocalStorageValues("Session_UserID")) : ""),
            SearchBy: "",
            totalCount: 0,
            RecCount: 10,
            pageCount: 0,
            ReasonError: "",
            isFavorited: false,
            ContentClassName: isFromLink ? "container-fluid" : "container-fluid content-section",
            /*[03/11/23, PC_CPW_113_02, Vishwa S]*/
            qtyenteredError: [],
            qtyenteredValue: "",
            IsQtyenteredError: [],
            PageNo: 1,
            searchClick: false
        }
    };


    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        /**
        *RMA_PC_04
        * to get the dropdown data
        */
        /*[08/22/22 , PC_05]Accessing STKIssueCart and RMA from mobile for web view - Priyanka D*/
        if (isFromLink) {
            window.document.title = "RMA";
            let BO = {
                Session_USERID: mob_Session_USERID,
                Session_BUSUNIT: mob_Session_BUSUNIT,
                Token: Token,
                IsFromMob: true
            }

            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            RMAAction.RMAPageLoadActionUnAuth(BO)

        } else {
            let BO = {
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_Userid: CookieService.getLocalStorageValues("Session_UserID")
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            RMAAction.RMAPageLoadAction(BO)
        }
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        RMAAction.getCurrentFavPage(getFavPageBO);
        RMAStore.on('PageLoad', this.RMAPageLoadResponse.bind(this));
        RMAStore.on('Search', this.SearchButtonClickResponse);
        RMAStore.on('Save', this.SaveButtonClickResponse.bind(this));
        RMAStore.on('Reason', this.ReasonSelectResponse.bind(this));
        RMAStore.on('favpage', this.loadFavPageResponse.bind(this));
        RMAStore.on('updateFavPage', this.updateFavPageResponse.bind(this));

        let today = new Date();
        let before = new Date();
        //let d = this.handledate(today)
        before.setMonth(today.getMonth() - 3);
        this.setState({ StartDate: before, EndDate: today });
        if (isFromLink) {
            document.getElementById("ContentDiv").style.marginTop = "25px"
        } else {
            document.getElementById("ContentDiv").style.marginTop = "150px"
        }
    }
    componentWillUnmount() {
        RMAStore.removeListener('PageLoad', this.RMAPageLoadResponse.bind(this));
        RMAStore.removeListener('Search', this.SearchButtonClickResponse);
        RMAStore.removeListener('Save', this.SaveButtonClickResponse.bind(this));
        RMAStore.removeListener('Reason', this.ReasonSelectResponse.bind(this));
    }
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(RMAStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        if (RMAStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(RMAStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(RMAStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        //this.refreshMenu();
    };
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            if (isFromLink) {
                let insertFavPageBO = {
                    Session_USERID: mob_Session_USERID,
                    pageURL: currentPagePath.toLowerCase(),
                    pageTitle: "Return to Inventory", //CPW-160 Vishwa S
                    Session_BUSUNIT: mob_Session_BUSUNIT
                }
                RMAAction.insertFavPage(insertFavPageBO)
            } else {
                let insertFavPageBO = {
                    Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                    pageURL: currentPagePath.toLowerCase(),
                    pageTitle: "Return to Inventory", //CPW-160 Vishwa S
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
                }
                RMAAction.insertFavPage(insertFavPageBO)
            }
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            RMAAction.deleteFavPage(deleteFavPageBO)
        }
    };
    /**         
     * RMA_PC_05
     * */
    RMAPageLoadResponse = () => {
        
        let Response = JSON.parse(RMAStore.GridData);
        if (Response.ErrorMessage != undefined) {
            if (Response.ErrorMessage[0] != undefined) {
                if (Response.ErrorMessage[0].lblerror == "InvalidToken") {
                    this.props.history.push({
                        pathname: '/',
                    });
                }
            }
        }
        else {
            let params = new URLSearchParams(window.location.search);
            // Add a third parameter.
            //URLSearchParams.set("InsiteonlineRMA", "RMA")

            // URLSearchParams=URLSearchParams(window.location.search) = "/InsiteOnlineRMA"
            let locEMPDD = Response.EmpTable
            let LocBu = Response.BuTable
            let locboolean = false
            let emp = []
            let bu = []
            /*[09/11/23, PC_CPW_113_14, Vishwa S]*/
            let locObj = "";
            if (SESSION_TRUCK_USER == "True") {
                if (isFromLink) {
                    locObj = {
                        value: mob_Session_USERID,
                        label: mob_Session_USERID
                    }
                }
                else {
                    locObj = {
                        value: CookieService.getLocalStorageValues("Session_UserID"),
                        label: CookieService.getLocalStorageValues("Session_UserID")
                    }
                }
            }
            if (locEMPDD != null && locEMPDD != undefined) {
                if (locEMPDD.length > 0) {
                    locEMPDD.map((val, index) => {
                        //if (index == 0) {
                        //    let defaultvalue = {
                        //        value: "0",
                        //        label: "Select Employee ID"/*"--Select Ship To--"*/
                        //    }
                        //    emp.push(defaultvalue)
                        //}
                        let localArray = {
                            value: val.ISA_EMPLOYEE_ID,
                            label: val.EMP_NAME
                        }

                        emp.push(localArray)

                    });
                }
            }
            if (LocBu != null && LocBu != undefined) {
                if (LocBu.length > 0) {
                    LocBu.map((val, index) => {
                        if (index == 0 && LocBu.length > 1) {
                            let defaultvalue = {
                                value: "0",
                                label: "Select"
                            }
                            bu.push(defaultvalue)
                        }
                        let localArray = {
                            value: val.ISA_BUSINESS_UNIT,
                            label: val.DESCRIPT
                        }

                        bu.push(localArray)

                    });
                }
            }
            //[10/16/22, Bug - 2727 - To check BU null or undefined condition , Dhevanesam R]
            if (LocBu != null && LocBu != undefined) {
                if (LocBu.length > 1) {
                    locboolean = true
                }
            }

            this.setState({ EmpDD: emp, BuDD: Response.BuTable, BuBoolean: locboolean, BuDD: bu, Empval: bu[0].label, EmpId: locObj })
            console.log("RMAResponse", Response)
            console.log("RMAResponseBU", bu)
        }
    }
    /**
    *RMA_PC_10
   **/
    SearchButtonClickResponse = () => {
        let Response = JSON.parse(RMAStore.GridData);
        let grid = Response.Table
        let locGridData = []
        let count = Response.FlagTable[0].totalcount;
        console.log("Response", Response.FlagTable[0].totalcount)
        locGridData = grid.filter((val, idx) => idx < 10)
        let pg = Math.ceil((count > 0 ? count : 0) / this.state.RecCount);
        locGridData.forEach((value, index) => {

            value.reason = "";
            value.qtyentered = ""; /*[03/11/23, PC_CPW_113_05, Vishwa S]*/
            value.Changed = false;
            value.Returntype = "";
            value.ReturnBU = "";

        });
        ReasonChangedArr = []; /*[30/11/23, PC_CPW_113_24, Vishwa S]*/
        this.setState({ GridData: locGridData, totalCount: count, pageCount: pg, searchClick: true })
    }
    /**
     * RMA_PS_
     * */
    SaveButtonClickResponse = () => {
        let Response = JSON.parse(RMAStore.GridData);
        let error = Response.FlagTable[0].Msg
        if (error != undefined && error != "") {

            this.setState({ ReasonError: error });
            $(`#Success-popup`).modal('show')
        }
        if (isFromLink) {
            let BO = {
                Session_USERID: mob_Session_USERID,
                Session_BUSUNIT: mob_Session_BUSUNIT,
                ShipDateStart: this.state.StartDate,
                ShipDateEnd: this.state.EndDate,
                txtSearchCriteria: this.state.Cirteria,
                DrpEmployee: SESSION_TRUCK_USER == "True" && SESSION_TRUCK_USER !== undefined && SESSION_TRUCK_USER !== null ? mob_Session_USERID : this.state.EmpId.value, //CPW-113 Vishwa S
                DropSearchBy: this.state.SearchBy.value,
                RadioContains: this.state.RContainsAny == true ? "True" : "False",
                PageNo: "1",
                SESSION_TRUCK_USER: SESSION_TRUCK_USER
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            //[07/02/24, CPW-240 accordion is closed before going for a search, Vishwa S]
            $('.header-arrow').removeClass('accordion-arrow-change');
            $('.content-row').addClass('d-none');
            RMAAction.SearchButtonClickAction(BO)
            this.setState({ PageNo: 1 });
        } else {
            let BO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                ShipDateStart: this.state.StartDate,
                ShipDateEnd: this.state.EndDate,
                txtSearchCriteria: this.state.Cirteria,
                DrpEmployee: SESSION_TRUCK_USER == "True" && SESSION_TRUCK_USER !== undefined && SESSION_TRUCK_USER !== null ? CookieService.getLocalStorageValues("Session_UserID") : this.state.EmpId.value, //CPW-113 Vishwa S
                DropSearchBy: this.state.SearchBy.value,
                RadioContains: this.state.RContainsAny == true ? "True" : "False",
                PageNo: "1",
                SESSION_TRUCK_USER: SESSION_TRUCK_USER
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            //[07/02/24, CPW-240 accordion is closed before going for a search, Vishwa S]
            $('.header-arrow').removeClass('accordion-arrow-change');
            $('.content-row').addClass('d-none');
            RMAAction.SearchButtonClickAction(BO)
            this.setState({ PageNo: 1 });
        }

    }
    /**
     * RMA_PS_
     * */
    ReasonSelectResponse = () => {
        let Response = JSON.parse(RMAStore.GridData);
        let index = Response.FlagTable[0].Index
        let error = Response.FlagTable[0].msg
        //11/8/22, Bug - 2860 - RMA_ Values under Return Type and Return to BU are exchanged, Dhevanesam R]
        let bu = Response.FlagTable[0].lblReturnToBU
        let type = Response.FlagTable[0].lblReturnType
        let GridData = [...this.state.GridData];
        if (error != undefined && error != "") {
            GridData[index] = { ...GridData[index], reason: "" };
            this.setState({ ReasonError: error });
        }
        else {

            GridData[index] = { ...GridData[index], Returntype: type, ReturnBU: bu, Changed: true };
            ReasonChangedArr.push(((this.state.PageNo - 1) * this.state.RecCount) + index) /*[30/11/23, PC_CPW_113_20, Vishwa S]*/
            this.setState({ GridData });
            this.setState({ ReasonError: "" });

        }

    }
    /**
     * RMA_PS_16
     * */
    OnRadioChange = (str) => {
        if (str == "Any") {
            this.setState({ RContainsAll: false, RContainsAny: true, searchClick: false, GridData: [], totalCount: 0 }); //CPW-113 Vishwa S
        }
        else {
            this.setState({ RContainsAll: true, RContainsAny: false, searchClick: false, GridData: [], totalCount: 0 }); //CPW-113 Vishwa S
        }
    }
    /**
     * RMA_PS_15
     * */
    handleDatePicker = (date, name) => {
        //date.preventDefault();
        //;

        let dateOL = this.handledate(date);
        this.setState({
            [name]: date,
            searchClick: false, GridData: [], totalCount: 0 //CPW-113 Vishwa S
        });

        console.log("Date", date);
        console.log("Date", dateOL);
    };
    handledate = (date) => {
        if (date != null) {
            return (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear())
        }

    }
    /**
     * RMA_PS_09
     * */
    SearchButtonClick = (pg) => {
        if (this.state.StartDate == "" || this.state.StartDate == undefined || this.state.EndDate == "" || this.state.EndDate == undefined) {
            // Regression Bug- 5480 - Return to inventory UI POP up issue - K. Surya
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please select a date range"
            });
            return;
        }
        if (this.state.SearchBy.value == "" || this.state.SearchBy.value == undefined) {
            if (this.state.Cirteria != "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select any criteria"
                });
                // alert("Select any criteria")
                return;
            }
        }
        let BO = {}
        if (isFromLink) {
            BO = {
                Session_USERID: mob_Session_USERID,
                Session_BUSUNIT: mob_Session_BUSUNIT,
                ShipDateStart: this.state.StartDate,
                ShipDateEnd: this.state.EndDate,
                txtSearchCriteria: this.state.Cirteria,
                DrpEmployee: SESSION_TRUCK_USER == "True" && SESSION_TRUCK_USER !== undefined && SESSION_TRUCK_USER !== null ? mob_Session_USERID : this.state.EmpId.value, /*[09/11/23, PC_CPW_113_11, Vishwa S]*/
                DropSearchBy: this.state.SearchBy.value,
                RadioContains: this.state.RContainsAny == true ? "True" : "False",
                PageNo: pg,
                SESSION_TRUCK_USER: SESSION_TRUCK_USER,
                //Regression bug 4288 -Yuvarani K.
                sortValue: sortVal
            }
        } else {
            BO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                ShipDateStart: this.state.StartDate,
                ShipDateEnd: this.state.EndDate,
                txtSearchCriteria: this.state.Cirteria,
                DrpEmployee: SESSION_TRUCK_USER == "True" && SESSION_TRUCK_USER !== undefined && SESSION_TRUCK_USER !== null ? CookieService.getLocalStorageValues("Session_UserID") : this.state.EmpId.value, /*[09/11/23, PC_CPW_113_11, Vishwa S]*/
                DropSearchBy: this.state.SearchBy.value,
                RadioContains: this.state.RContainsAny == true ? "True" : "False",
                PageNo: pg,
                SESSION_TRUCK_USER: SESSION_TRUCK_USER,
                //Regression bug 4288 -Yuvarani K.
                sortValue: sortVal
            }
        }
        ReasonChangedArr = []; /*[30/11/23, PC_CPW_113_23, Vishwa S]*/

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        $('.header-arrow').addClass('accordion-arrow-change');
        $('.content-row').removeClass('d-none');
        $('.header-arrow').removeClass('accordion-arrow-change');
        $('.content-row').addClass('d-none');
        RMAAction.SearchButtonClickAction(BO)
        this.setState({ PageNo: pg, ReasonError: "" });
    }
    /**
     * RMA_PS_18
     * */
    onhandleChange = (event) => {
        console.log("valueRMA", event.name)

        this.setState({ SearchBy: event, searchClick: false, GridData: [], totalCount: 0 }) //CPW-113 Vishwa S

    }
    /**
    * RMA_PS_17
    * */
    onhandleEmpChange = (event) => {
        //console.log("valueRMA", event.name)
        this.setState({ EmpId: event, searchClick: false, GridData: [], totalCount: 0 }) //CPW-113 Vishwa S
    }
    /**
     * RMA_PS_19
     * */
    onhandleCriteriaChange = (event) => {

        this.setState({ [event.target.name]: event.target.value, searchClick: false, GridData: [], totalCount: 0 }) //CPW-113 Vishwa S
    }
    ClearSearch = () => {
        this.setState({ Cirteria: "" })
    }
    onAccordianClick = (event, index) => {
        const $currentOpenAccordion = $(`#contentrow-${index}`);
        const isCurrentlyOpen = !$currentOpenAccordion.hasClass('d-none');

        // Close all open accordions
        $('.content-row').addClass('d-none');
        $('.accordion-arrow').removeClass('accordion-arrow-change');

        if (!isCurrentlyOpen) {
            // Open the clicked accordion
            $currentOpenAccordion.removeClass('d-none');
            $(`#arrow-${index}`).addClass('accordion-arrow-change');
        }

        $('tr').removeClass('tr-border');
        if (!isCurrentlyOpen) {
            $(event.currentTarget).parent('tr').addClass('tr-border');
        }
    };
    /***
     * RMA_PS_13
     * */
    OnReasonChange = (e, index, value, name) => {
        let label = e.label
        const re = SDIConstants.quantityRegEX;
        let GridData = [...this.state.GridData];
        let qtyenteredValue = "";
        /*[30/11/23, PC_CPW_113_19, Vishwa S]*/
        if (name == "reason") {
            if (e.value != "") {
                GridData[index] = { ...GridData[index], reason: e, Changed: true };
                ReasonChangedArr.push(((this.state.PageNo - 1) * this.state.RecCount) + index)
            }
            else {
                GridData[index] = { ...GridData[index], reason: e, Changed: false };
                let reasonIndex = ReasonChangedArr.indexOf(((this.state.PageNo - 1) * this.state.RecCount) + index);

                if (reasonIndex !== -1) {
                    ReasonChangedArr.splice(reasonIndex, 1);
                }
            }

        }
        else {
            let left = value.QtyRemaining
            /*[03/11/23, PC_CPW_113_03, Vishwa S]*/
            if (e.target.value === '' || re.test(e.target.value)) {
                GridData[index] = { ...GridData[index], qtyentered: e.target.value };
                if (parseInt(e.target.value) <= left || e.target.value == "") {

                    let itemIndex = this.state.IsQtyenteredError.indexOf(((this.state.PageNo - 1) * this.state.RecCount) + index);

                    if (itemIndex !== -1) {
                        this.state.IsQtyenteredError.splice(itemIndex, 1);
                    }
                }
                else {
                    if (!this.state.IsQtyenteredError.includes(((this.state.PageNo - 1) * this.state.RecCount) + index)) {
                        this.state.IsQtyenteredError.push(((this.state.PageNo - 1) * this.state.RecCount) + index)
                    }
                }
            }
            //if (parseInt(e.target.value) <= left) {
            //    GridData[index] = { ...GridData[index], qtyentered: e.target.value };
            //    qtyenteredError = false;
            //}
            //else {
            //    GridData[index] = { ...GridData[index], qtyentered: 0 };
            //    qtyenteredError = true;
            //    if (e.target.value == "") {
            //        qtyenteredError = false;
            //    }
            //} 

        }

        this.setState({ GridData });
        if (name == "reason") {
            if (isFromLink) {
                let BO = {
                    Session_BUSUNIT: mob_Session_BUSUNIT,
                    drpreason: e.value,
                    INV_ITEM_ID: value.INV_ITEM_ID,
                    SHIP_FROM_BU: value.SHIP_FROM_BU,
                    Index: index,

                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                RMAAction.ReasonSelectAction(BO)
            } else {
                let BO = {
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                    drpreason: e.value,
                    INV_ITEM_ID: value.INV_ITEM_ID,
                    SHIP_FROM_BU: value.SHIP_FROM_BU,
                    Index: index,

                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                RMAAction.ReasonSelectAction(BO)
            }
        }
    }
    /**
    *RMA_PS_
   **/
    SaveButtonClick = () => {
        /*[03/11/23, PC_CPW_113_04, Vishwa S]*/
        let conditionVar = true;
        let intQtyentered = true;
        if (this.state.IsQtyenteredError.length != 0) {
            conditionVar = false;
            intQtyentered = false;
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Qty returned cannot be greater than remaining qty"
            });
        }
        else if (this.state.GridData != undefined && this.state.GridData != []) {
            if (this.state.GridData.length > 0) {
                this.state.GridData.forEach((value) => {
                    let qtyentered = value.qtyentered;
                    if (qtyentered !== "" && parseInt(qtyentered) !== 0) {
                        intQtyentered = false;
                    }
                    if (parseInt(qtyentered) == 0) {
                        conditionVar = false;
                        intQtyentered = false;
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Qty returned cannot be zero"
                        });
                    }
                })
            }
        }
        if (intQtyentered) {
            conditionVar = false;
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter returned qty for at least one order to save"
            });
        }
        if (conditionVar) {
            let checkarr = []
            let drpreason = ""
            if (this.state.GridData != undefined && this.state.GridData != []) {
                if (this.state.GridData.length > 0) {
                    this.state.GridData.forEach((value) => {
                        let qtyentered = value.qtyentered;
                        if (qtyentered == "") {
                            qtyentered = 0;
                        }
                        if (value.Changed == true && qtyentered != 0) {
                            if (value.reason.value != "") {
                                drpreason = value.reason.value
                            }
                            checkarr.push({
                                ORDER_NO: value.ORDER_NO,
                                ORDER_INT_LINE_NO: value.ORDER_INT_LINE_NO,
                                LINE_REASON_CD: value.LINE_REASON_CD,
                                txtQTYReturned: parseInt(qtyentered),
                                PRODUCT_ID: value.PRODUCT_ID,
                                SHIP_FROM_BU: value.SHIP_FROM_BU,
                                SHIP_ID: value.SHIP_ID,
                                SHIP_DATE: value.SHIP_DATE,
                                BUSINESS_UNIT_BI: value.BUSINESS_UNIT_BI,
                                INVOICE: value.INVOICE,
                                DEMAND_LINE_NO: value.DEMAND_LINE_NO,
                                DrpReason: drpreason,
                                LINE_SEQ_NUM: value.LINE_SEQ_NUM,
                                /*[31/01/24, PC_CPW_240_01, Vishwa S]*/
                                ChargeCode: "",
                                WorkOrder: value.ISA_WORK_ORDER_NO
                            })
                        }


                    })
                }
            }
            if (checkarr != undefined) {
                if (checkarr.length > 0) {
                    ReasonChangedArr = []; /*[30/11/23, PC_CPW_113_25, Vishwa S]*/
                    if (isFromLink) {
                        let BO = {
                            Session_USERID: mob_Session_USERID,
                            Session_BUSUNIT: mob_Session_BUSUNIT,
                            Session_WEBSITEID: "",
                            lblBU: "I0W01",
                            DATA: checkarr
                        }
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        RMAAction.SaveButtonClickAction(BO)
                    } else {
                        let BO = {
                            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
                            lblBU: "I0W01",
                            DATA: checkarr
                        }
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        RMAAction.SaveButtonClickAction(BO)
                    }
                }
            }

        }


    }
    /**
     * RMA_PS_21
     * */
    Sorting = (value, column) => {
        //Regression bug 4288 -Yuvarani K.
        sortVal = value;
        if (isFromLink) {
            let BO = {
                Session_USERID: mob_Session_USERID,
                Session_BUSUNIT: mob_Session_BUSUNIT,
                ShipDateStart: this.state.StartDate,
                ShipDateEnd: this.state.EndDate,
                txtSearchCriteria: this.state.Cirteria,
                DrpEmployee: SESSION_TRUCK_USER == "True" && SESSION_TRUCK_USER !== undefined && SESSION_TRUCK_USER !== null ? mob_Session_USERID : this.state.EmpId.value, //CPW-113 Vishwa S
                DropSearchBy: this.state.SearchBy.value,
                RadioContains: this.state.RContainsAny == true ? "True" : "False",
                PageNo: this.state.pageNo,
                sortColumn: column,
                sortValue: value,
                SESSION_TRUCK_USER: SESSION_TRUCK_USER
            }
            ReasonChangedArr = []; /*[30/11/23, PC_CPW_113_26, Vishwa S]*/
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            RMAAction.SearchButtonClickAction(BO)
        } else {
            let BO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                ShipDateStart: this.state.StartDate,
                ShipDateEnd: this.state.EndDate,
                txtSearchCriteria: this.state.Cirteria,
                DrpEmployee: SESSION_TRUCK_USER == "True" && SESSION_TRUCK_USER !== undefined && SESSION_TRUCK_USER !== null ? CookieService.getLocalStorageValues("Session_UserID") : this.state.EmpId.value, //CPW-113 Vishwa S
                DropSearchBy: this.state.SearchBy.value,
                RadioContains: this.state.RContainsAny == true ? "True" : "False",
                PageNo: this.state.pageNo,
                sortColumn: column,
                sortValue: value,
                SESSION_TRUCK_USER: SESSION_TRUCK_USER
            }
            ReasonChangedArr = []; /*[30/11/23, PC_CPW_113_26, Vishwa S]*/
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            RMAAction.SearchButtonClickAction(BO)
        }
        //[07/02/24, CPW-240, Vishwa S]
        $('.header-arrow').removeClass('accordion-arrow-change');
        $('.content-row').addClass('d-none');
        //this.setState({ PageNo: pg, ReasonError: "" });
    }
    /**
     * RMA_PS_23
     * */
    Closepopup = () => {
        $(`#Success-popup`).modal('hide')
    }
    /**
     * RMA_PS_20
     * */
    GridDataBind = () => {
        let count = 0;
        if (this.state.GridData != undefined) {
            if (this.state.GridData.length > 0) {
                return this.state.GridData.map((value, index) => {
                    if (count < 10) {
                        return (
                            <tbody>
                                <tr id={index}>

                                    <td className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, index)}>
                                        <span className="accordion-arrow header-arrow" id={`arrow-${index}`}></span>
                                    </td>
                                    <td className="">{value.ORDER_NO}</td>
                                    <td className="pl-4">{value.ORDER_INT_LINE_NO}</td>
                                    <td className="">{value.INV_ITEM_ID}</td>
                                    <td className="">{value.DESCR}</td>
                                    <td className="">{value.ISA_EMPLOYEE_ID}</td>
                                    <td className="">{value.SHIP_DATE}</td>
                                </tr>
                                <tr className="p d-none content-row" id={`contentrow-${index}`} >
                                    <td colSpan={12} className="hiddenRow" style={backgout}>
                                        <div className="accordian-body  py-1 replen-row" id="order-row-1">
                                            <div className="row mx-0 pb-3">
                                                <div className="col-md-12 pl-5">
                                                    <div className="row">

                                                        <div className="w-100 float-left mt-4">
                                                            <div className="col-md-6 col-lg-4 col-sm-12 float-left mb-3">
                                                                <div className="row align-items-center">
                                                                    <div className="col-md-4 float-left">
                                                                        <label className="catalog-label">Reason CD:</label>
                                                                    </div>
                                                                    <div className="col-md-6 float-left">
                                                                        <Select
                                                                            className="DropDown-Font-Size"
                                                                            options={ReasonOption}
                                                                            value={value.reason}
                                                                            onChange={e => this.OnReasonChange(e, index, value, "reason")} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 col-lg-4 col-sm-12  float-left mb-3">
                                                                <div className="row align-items-center">
                                                                    <div className="col-md-4 float-left">
                                                                        <label className="catalog-label">Qty Returned:</label>
                                                                    </div>
                                                                    <div className="col-md-6 float-left">
                                                                        {/*[03/11/23, PC_CPW_113_01, PC_CPW_113_21, Vishwa S]*/}
                                                                        {/*{value.Changed == true ?*/}
                                                                        <React.Fragment><input type="text" min="0" defaultValue={0} placeholder={ReasonChangedArr.includes(((this.state.PageNo - 1) * this.state.RecCount) + index) ? "Enter Qty" : null} disabled={ReasonChangedArr.includes(((this.state.PageNo - 1) * this.state.RecCount) + index) ? false : true} maxLength="5" value={value.qtyentered} name="qtyentered" step="1" inputmode="numeric" onChange={(e) => this.OnReasonChange(e, index, value, "qtyentered")} className="form-control float-left mr-2 " />
                                                                        </React.Fragment>{/* : null}*/}
                                                                    </div>
                                                                    {/*[03/11/23, PC_CPW_113_01, Vishwa S]*/}
                                                                    {value.Changed == true ? <span>{this.state.IsQtyenteredError.includes(((this.state.PageNo - 1) * this.state.RecCount) + index) ? <span className="errorspan float-left ml-3">Qty cannot be greater than remaining qty</span> : null}</span> : null}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 col-lg-4 col-sm-12  float-left mb-3">
                                                                <div className="row align-items-center">
                                                                    <div className="col-md-4 float-left">
                                                                        <label className="catalog-label  mb-0">Qty remaining:</label>
                                                                    </div>
                                                                    <div className="col-md-6 float-left">
                                                                        <label className="catalog mb-0" >{value.QtyRemaining}</label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="w-100 float-left">
                                                            <div className="col-md-6 col-lg-4 col-sm-12  float-left mb-3">
                                                                <div className="row align-items-center">
                                                                    <div className="col-md-4 float-left">
                                                                        <label className="catalog-label  mb-0">UOM:</label>
                                                                    </div>
                                                                    <div className="col-md-6 float-left">
                                                                        <label className="catalog mb-0"  >{value.UNIT_OF_MEASURE}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/*<div className="col-md-6 col-lg-4 col-sm-12  float-left mb-3">
                                                                <div className="row align-items-center">
                                                                    <div className="col-md-4 float-left">
                                                                        <label className="catalog-label">Unit Price:</label>
                                                                    </div>
                                                                    <div className="col-md-6 col-md-6 col-sm-12 float-left">
                                                                        <label className="catalog mb-0">{value.NET_UNIT_PRICE}</label>
                                                                    </div>
                                                                </div>
                                                            </div>*/}
                                                            <div className="col-md-6 col-lg-4 col-sm-12  float-left mb-3">
                                                                <div className="row align-items-center">
                                                                    <div className="col-md-4 float-left">
                                                                        <label className="catalog-label  mb-0">Charge Code:</label>
                                                                    </div>
                                                                    <div className="col-md-6 float-left">
                                                                        <label className="catalog-label mb-0 " >{value.ISA_CUST_CHARGE_CD}</label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6 col-lg-4 col-sm-12 float-left mb-3">
                                                                <div className="row align-items-center">
                                                                    <div className="col-md-4 float-left">
                                                                        <label className="catalog-label  mb-0">Work Order No:</label>
                                                                    </div>
                                                                    <div className="col-md-6 float-left">
                                                                        <label className="catalog mb-0"  >{value.ISA_WORK_ORDER_NO}</label>
                                                                    </div>
                                                                </div>
                                                            </div>


                                                        </div>
                                                        <div className="w-100 float-left">
                                                            <div className="col-md-6 col-lg-4 col-sm-12  float-left mb-3">
                                                                <div className="row align-items-center">
                                                                    <div className="col-md-4 float-left">
                                                                        <label className="catalog-label">Machine No:</label>
                                                                    </div>
                                                                    <div className="col-md-6 float-left">
                                                                        <label className="catalog mb-0">{value.ISA_MACHINE_NO}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 col-lg-4 col-sm-12  float-left mb-3">
                                                                <div className="row align-items-center">
                                                                    <div className="col-md-4 float-left">
                                                                        <label className="catalog-label mt-2 mb-0">Return To BU:</label>
                                                                    </div>
                                                                    <div className="col-md-6 float-left">
                                                                        <label className="catalog mb-0" >{value.ReturnBU}</label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6 col-lg-4 col-sm-12  float-left mb-3">
                                                                <div className="row align-items-center">
                                                                    <div className="col-md-4 float-left">
                                                                        <label className="catalog-label mt-2 mb-0">Return Type:</label>
                                                                    </div>
                                                                    <div className="col-md-6 float-left">
                                                                        <label className="catalog mb-0 "  >{value.Returntype}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="w-100 float-left">
                                                            <div className="col-md-6 col-lg-4 col-sm-12  float-left mb-3">
                                                                <div className="row align-items-center">
                                                                    <div className="col-md-4 float-left">
                                                                        <label className="catalog-label">Serial Out:</label>
                                                                    </div>
                                                                    <div className="col-md-6 float-left">
                                                                        <label className="catalog">{}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 col-lg-4 col-sm-12  float-left mb-3">
                                                                <div className="row align-items-center">
                                                                    <div className="col-md-4 float-left">
                                                                        <label className="catalog-label mb-0">Serial In:</label>
                                                                    </div>
                                                                    <div className="col-md-6 float-left">
                                                                        <label className="catalog mb-0">{value.SERIAL_ID}</label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6 col-lg-4 col-sm-12  float-left mb-3">
                                                                <div className="row align-items-center">
                                                                    <div className="col-md-4 float-left">
                                                                        <label className="catalog-label mb-0">Ship Id:</label>
                                                                    </div>
                                                                    <div className="col-md-6 float-left">
                                                                        <label className="catalog mb-0">{value.SHIP_ID}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                        )
                        count = count + 1
                    }

                })
            }
        }
    }
    /**
     * RMA_PC_08
     * */
    CancelButtonClick = (e) => {
        let today = new Date();
        let before = new Date();
        //let d = this.handledate(today)
        before.setMonth(today.getMonth() - 3);
        //CPW-113 Vishwa S
        let locObj = ""
        if (SESSION_TRUCK_USER == "True") {
            if (isFromLink) {
                locObj = {
                    value: mob_Session_USERID,
                    label: mob_Session_USERID
                }
            }
            else {
                locObj = {
                    value: CookieService.getLocalStorageValues("Session_UserID"),
                    label: CookieService.getLocalStorageValues("Session_UserID")
                }
            }
        }
        ReasonChangedArr = []; /*[30/11/23, PC_CPW_113_22, Vishwa S]*/

        this.setState({
            SearchByOption: options,
            RContainsAny: true,
            RContainsAll: false,
            SearchBy: "", StartDate: before, EndDate: today, EmpId: locObj, Cirteria: "",
            searchClick: false, GridData: [], totalCount: 0 //CPW-113 Vishwa S
        });
    }
    handlePageClick = (data) => {
        let pageNo = data.selected + 1;



        this.setState({ PageNo: pageNo });

        this.SearchButtonClick(pageNo)




        //;
        // isPostBack = false;
    };

    render() {
        // console.log("BUDD", this.state.BuDD[0].label)
        return (
            <>
                <div className={this.state.ContentClassName} id="ContentDiv"  >
                    <div className="row">
                        <div id="accordion" className="col-lg-12 float-left mt-3 p-0">
                            <div className="col-lg-12 float-left px-0">
                                <div className="col-md-12 page-heading mb-3 float-left p-0">
                                    <h5 className="page-title px-3"><Trans>Return to Inventory</Trans></h5> {/*[10/11/23, CPW-160 Hamburger menu in MM app, Vishwa S]*/}
                                    <span className="info-container float-left">
                                        <img className=" mr-2 mt-3 float-left" src="Images/info-icon.png" />
                                        <span className="Grid-info-icon3 text-left sdi-fede-tooltippickup "><Trans>{SESSION_TRUCK_USER == "True" ? "The return to inventory page is used to return inventory previously issued on a work order back to your truck." : "The return to inventory page is used to return inventory previously issued on a work order back to your inventory."}</Trans></span> {/*[30/11/23, PC_CPW_215_01, Vishwa S]*/}
                                    </span>
                                    {!isFromLink ?
                                        <div className="fav-item-maintenance-icon mt-1">
                                            <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                            <label htmlFor="checkbox-OrdStatus">
                                                <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                                    <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                        <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                        <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                        <g className="grp7" opacity={0} transform="translate(7 6)">
                                                            <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                            <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                        </g>
                                                        <g className="grp6" opacity={0} transform="translate(0 28)">
                                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                            <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                        </g>
                                                        <g className="grp3" opacity={0} transform="translate(52 28)">
                                                            <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                            <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                        </g>
                                                        <g className="grp2" opacity={0} transform="translate(44 6)">
                                                            <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                        </g>
                                                        <g className="grp5" opacity={0} transform="translate(14 50)">
                                                            <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                            <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                        </g>
                                                        <g className="grp4" opacity={0} transform="translate(35 50)">
                                                            <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                            <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                        </g>
                                                        <g className="grp1" opacity={0} transform="translate(24)">
                                                            <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                            <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                        </g>
                                                    </g>
                                                </svg>
                                            </label>
                                        </div> : null}
                                </div>
                            </div>
                            <div className="col-md-12 float-left border-bottom  mb-3">
                                <div className="row ">
                                    {/*CPW-201*/}
                                    {/*<div className="col-md-3 mb-3"> 
                                        <label className="catalog-label pr-1" style={{}}><span>RMA Number:</span></label>
                                        <label className="catalog-label">Next</label>
                                    </div>*/}
                                    <div className="col-md-12 mb-3">
                                        <label className="catalog-label pr-1" style={{}}><Trans>Business Unit:</Trans></label>
                                        {this.state.BuDD.length > 1 ?
                                            <Select
                                                className="DropDown-Font-Size"
                                            /> : <label className="col-lg-8 col-md-12 float-left p-0 catalog-label">{this.state.Empval}</label>}
                                    </div>
                                    <div className="col-md-3 mb-3 rmaclass">
                                        <label className="col-lg-5 col-md-12 float-left p-0 catalog-label form-label"><Trans>Start Date</Trans></label>
                                        <DatePicker className="form-control "
                                            id="OF"
                                            fixedHeight
                                            placeholderText="MM/DD/YYYY"
                                            dateFormat="MM/dd/yyyy"
                                            showMonthDropdown
                                            showYearDropdown
                                            selected={this.state.StartDate}
                                            maxDate={this.state.EndDate}
                                            onChange={(e) => this.handleDatePicker(e, "StartDate")}
                                        //value={this.state.FromDate}
                                        />
                                        {/* Regression Bug UI issue in Calendar in Return to inventory panel */}
                                        <span className="calendar-icon-expedite-po" onClick={() => $(`#OF`).focus()} />
                                    </div>
                                    <div className="col-md-3 mb-3 rmaclass">
                                        <label className="col-lg-5 col-md-12 float-left p-0 catalog-label form-label"><Trans>To Date</Trans></label>
                                        <DatePicker className="form-control"
                                            id="OT"
                                            fixedHeight
                                            placeholderText="MM/DD/YYYY"
                                            dateFormat="MM/dd/yyyy"
                                            showMonthDropdown
                                            showYearDropdown
                                            selected={this.state.EndDate}
                                            minDate={this.state.StartDate}
                                            onChange={(e) => this.handleDatePicker(e, "EndDate")}
                                        //value={this.state.FromDate}
                                        />
                                        {/* Regression Bug UI issue in Calendar in Return to inventory panel */}
                                        <span className="calendar-icon-expedite-po" onClick={() => $(`#OT`).focus()} />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <label className="col-lg-5 col-md-12 float-left p-0 catalog-label form-label" style={{}}><Trans>Search By:</Trans></label>
                                        <div className="col-lg-12 col-md-12 float-left p-0 col-12">
                                            <Select
                                                className="DropDown-Font-Size"
                                                options={this.state.SearchByOption}
                                                value={this.state.SearchBy}
                                                onChange={e => this.onhandleChange(e)}
                                                name="SearchBy"
                                            />
                                        </div>
                                    </div>
                                    {/****WW-219**/}
                                    <div className="col-md-3 mb-3">
                                        <label className="col-lg-3 col-md-12 float-left p-0 catalog-label form-label" style={{}}><Trans>Criteria:</Trans> </label>
                                        {this.state.SearchBy.value == "3" ?
                                            <div className="col-lg-12 col-md-12 p-0 col-12">
                                                <Select
                                                    className="DropDown-Font-Size"
                                                    options={this.state.EmpDD}
                                                    value={this.state.EmpId}
                                                    onChange={e => this.onhandleEmpChange(e)}
                                                    isDisabled={SESSION_TRUCK_USER == "True" ? true : false}
                                                    inputProps={{ placeholder: "Select Employee ID" }}
                                                />
                                            </div> : <>
                                            <input type="text" className="col-md-12 form-control pr-4" maxLength="256" placeholder="Enter Criteria" name="Cirteria" value={this.state.Cirteria} onChange={e => this.onhandleCriteriaChange(e)} />
                                                {this.state.Cirteria ? <span className="search-cancel-header cursor-pointer" style={{ "right": "19px", "top":"50px" }} onClick={() => this.ClearSearch()}></span> : null}</>}

                                        <div className="col-md-12 p-0 mt-2">
                                            <label className="custom-radiobtn "><Trans>Contains Any</Trans>
                                                <input type="radio" name="RContainsAny" id="duration0" checked={this.state.RContainsAny} onChange={e => this.OnRadioChange("Any")} />
                                                <span className="checkmark checkmark-org"></span>
                                            </label>
                                            <label className="custom-radiobtn"> <Trans>Contains All</Trans>

                                                <input type="radio" name="RContainsAll" id="duration1" checked={this.state.RContainsAll} onChange={e => this.OnRadioChange("All")} />
                                                <span className="checkmark checkmark-org"></span>
                                            </label>
                                        </div>

                                    </div>
                                    {/********END*********/}




                                </div>

                                <div className="col-md-12 my-3 float-left p-0">
                                    <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4" onClick={(e) => this.SearchButtonClick("1")}><Trans>Search</Trans><span> </span><Trans>Filter</Trans></button>
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right px-4 mr-3" onClick={(e) => this.CancelButtonClick(e)} ><Trans>Clear</Trans></button>
                                </div>
                            </div>
                            <div id="collapseOne" className="card-body collapse show" data-parent="#accordion">

                            </div>



                        </div>
                    </div>

                    {this.state.GridData.length > 0 ?
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-md-12 mb-2 px-0">
                                    <div className="float-right">
                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4 mr-1" onClick={(e) => this.SaveButtonClick(e)} ><Trans>Save</Trans></button>

                                    </div>
                                    <div>
                                        <span className="DropDown-Font-Size errorcolour d-none">{this.state.ReasonError}</span>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className="table ZEUS_Grid chk-ordertbl">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th className=" position-sort-icon"><Trans>order_key</Trans><span> no</span><span className="sort-up1 ml-1" onClick={(e) => this.Sorting("ASC", "ORDER_NO")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "ORDER_NO")}><img src="Images/sort1.svg" /></span></th>
                                                <th className=" position-sort-icon">Ord Ln</th>
                                                <th className="position-sort-icon"><Trans>Product</Trans><span className="sort-up1 ml-1" onClick={(e) => this.Sorting("ASC", "INV_ITEM_ID")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "INV_ITEM_ID")}><img src="Images/sort1.svg" /></span></th>
                                                <th className=" position-sort-icon"><Trans>Description</Trans></th>
                                                <th className=" position-sort-icon">Emp Id <span className="sort-up1 ml-1" onClick={(e) => this.Sorting("ASC", "ISA_EMPLOYEE_ID")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "ISA_EMPLOYEE_ID")}><img src="Images/sort1.svg" /></span></th>
                                                <th className=" position-sort-icon"><Trans>Ship Date</Trans> <span className="sort-up1 ml-1" onClick={(e) => this.Sorting("ASC", "SHIP_DATE")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "SHIP_DATE")}><img src="Images/sort1.svg" /></span></th>
                                            </tr>
                                        </thead>
                                        {this.GridDataBind()}
                                    </table>
                                </div>
                            </div>
                        </div> : <span>{this.state.searchClick == true ? <section className="site-undercontruction container text-center center-panel pt-4"> {/*[06/11/23, PC_CPW_113_06, Vishwa S]*/}
                            <div className="img-section">
                                <img src="images/nosearch.jpg" alt="imagefile" />
                            </div>
                            <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                            </p>
                        </section> : null}</span>}
                    <div className="col-md-12">
                        {this.state.totalCount > 0 ? <>
                            <div className="col-md-12">
                                <span className="total-records mt-2 d-inline-block">
                                    <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.totalCount}</span>
                                </span>
                                {this.state.totalCount > this.state.RecCount ? <ReactPaginate
                                    previousLabel={<span className="right-pagination-arrow" />}
                                    nextLabel={<span className="left-pagination-arrow" />}
                                    previousClassName={'page-item'}
                                    nextClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextLinkClassName={'page-link'}
                                    disabledClassName={'disabled'}
                                    breakLabel={'...'}
                                    breakClassName={'page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageCount={this.state.pageCount}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={2}
                                    onPageChange={this.handlePageClick}
                                    containerClassName={'custom-pagination pagination float-right'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    activeClassName={'active'}
                                    hrefBuilder={() => '#'}
                                    forcePage={this.state.PageNo - 1}
                                /> : null}
                            </div></> : null}

                    </div>
                    <div className="modal" id="Success-popup">
                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                            <div className="modal-content">
                                {/* Modal Header */}
                                {/* Modal body */}

                                <div className="modal-body text-center">
                                    <div className="col-12 my-5">
                                        {/*<label className="confirm-label d-block">{this.state.Pick}</label>*/}
                                        <img class="mb-2" src="images/tick.svg" alt="tick"/>
                                        <label className="confirm-content d-block">{this.state.ReasonError}</label>
                                        {this.state.ReasonError != undefined && this.state.ReasonError != null && this.state.ReasonError.toLowerCase().includes("successfully") ? <label>Item return processed, return item to bin.</label> : null} {/*Vishwa S*/}
                                    </div>

                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" data-toggle="modal" onClick={e => this.Closepopup()}><Trans>Ok</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </>
        )
    }



}
export default withTranslation()(RMAComponent);